"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GiftVoucher;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function GiftVoucher(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#dc4326;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Gift voucher"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Payment_methods",
    "data-name": "Payment methods"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "giftvoucher",
    className: "cls-1",
    d: "M81.612,52H88V63.028a12.035,12.035,0,0,1-12,12H68.4V53.467a35.1,35.1,0,0,1,4.99,17.594A12.482,12.482,0,0,0,75.4,64.19c1.927,1.424,3.016,2.346,3.016,2.346A39.407,39.407,0,0,0,72.4,52.873c3.076.679,8.6.986,9.084-.656A1.494,1.494,0,0,0,81.612,52ZM64.4,52.294V75.028H24a12.035,12.035,0,0,1-12-12V52H51.186a1.494,1.494,0,0,0,.133.217c.442,1.5,5.056,1.375,8.2.828a39.412,39.412,0,0,0-5.9,13.491s1.09-.922,3.017-2.346a12.475,12.475,0,0,0,2.01,6.871A34.881,34.881,0,0,1,64.4,52.294ZM14.5,60.608a1.5,1.5,0,0,0,1.5,1.5H39.2a1.5,1.5,0,0,0,0-3H16A1.5,1.5,0,0,0,14.5,60.608ZM48.9,66a1.5,1.5,0,0,0-1.5-1.5H16a1.5,1.5,0,0,0,0,3H47.4A1.5,1.5,0,0,0,48.9,66ZM76,24.972H24a12.035,12.035,0,0,0-12,12V48H50.588c-.095-3.294-.009-5.633,1.8-6.4a8.086,8.086,0,0,1,8.279,2.012A31.925,31.925,0,0,0,64.4,47.361V24.972h4V47.364a31.9,31.9,0,0,0,3.738-3.751A8.085,8.085,0,0,1,80.414,41.6c1.8.766,1.891,3.105,1.8,6.4H88V36.972A12.035,12.035,0,0,0,76,24.972Z"
  })));
}